<template>
  <div v-loading="loading" class="rj-page-card">
    <div class="rj-page-card__title">
      收货信息
    </div>
    <div class="rj-page-card__content">
      <Collapse :open="true">
        <div slot="header">
          <collapseHeader :data="address" @chooseAddress="(val) => $emit('chooseAddress', val)" />
        </div>

        <p v-if="form.blackBoardProduct" style="margin-left:10px;color:red">
          【极其重要】智慧黑板RG-IIB-N86A下单要求：
          代理商下单过程请务必提供给平台商务「设备实际需要安装的地址」，且按照实际地址发货，否则新增地址上游供应商不予以上门安装，如有疑问请联系对应平台商务。
        </p>

        <p v-if="form.flatProduct" style="margin-left:10px;color:red">
          【极其重要】交互式智能平板（RG-IIB-K大屏）下单后的存储要求：
          因AG玻璃特性决定大屏存储期限只有3个月左右，如无法在收货后3个月内完成部署安装，因环境影响可能低概率出现玻璃水雾或霉变，此类情况非产品品质问题，若出现不支持退换，请联系400安排维修。
        </p>

        <slot name="freightInfo" />

        <productTable ref="productTable" v-bind="$props" :list="productList" />
      </Collapse>
      <slot />
    </div>
  </div>
</template>

<script>
import Collapse from '@/components/Collapse';
import { mapState } from 'vuex';
import CollapseHeader from './collapseHeader.vue';
import ProductTable from './productTable.vue';

export default {
  components: {
    Collapse,
    CollapseHeader,
    ProductTable
  },

  props: {
    rebateAmount: {
      type: [String, Number],
      default: 0
    },
    rebate: {
      type: [Number],
      default: 1
    },
    salesType: {
      type: [String, Number],
      default: ''
    },
    contractType: {
      type: String,
      default: ''
    },
    communicationOrderDiscount: {
      type: [String, Number],
      default: 1
    },
    form: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      productList: [],
      loading: false,
      address: {}
    };
  },

  computed: {
    ...mapState({
      freightProperty: state => state.enumeration.freightProperty
    })
  },

  methods: {
    validate () {
      let { productList, summariesData } = this.$refs.productTable.getSubmitData();
      return new Promise((resolve) => {
        if (!productList.length) {
          this.$notify.error({ message: '请选择产品' });
          resolve(false);
          return;
        }

        if (summariesData.beforeSplitProductPriceSigle !== summariesData.orderAmount) {
          this.$notify.error({ message: '拆分前单价与订单金额不符' });
          resolve(false);
          return;
        }

        for (let i = 0; i < productList.length; i++) {
          let item = productList[i];
          if (!item.productCode) {
            this.$notify.error({ message: '存在产品未选产品型号' });
            resolve(false);
            return;
          } else if (!item.materialNumberId) {
            this.$notify.error({ message: '存在产品未选择期料号' });
            resolve(false);
            return;
          } else if (!item.productNum) {
            this.$notify.error({ message: '存在产品未输入数量' });
            resolve(false);
            return;
          } else if (!item.expectedDeliveryDate) {
            this.$notify.error({ message: '存在产品未选择期望发货日期' });
            resolve(false);
            return;
          } else if (!item.freightProperty) {
            this.$notify.error({ message: '存在产品未选择货运属性' });
            resolve(false);
            return;
          } else if (!item.rate) {
            this.$notify.error({ message: '存在产品未选择税率' });
            resolve(false);
            return;
          }
        }

        resolve({ productList: productList, actualSettlementAmount: summariesData.settlementAmount, orderSales: summariesData.orderAmount });
      });
    },

    validateDraft () {
      let { productList, summariesData } = this.$refs.productTable.getSubmitData();

      return new Promise((resolve) => {
        resolve({ productList: productList, actualSettlementAmount: summariesData.settlementAmount, orderSales: summariesData.orderAmount });
      });
    }
  }

};
</script>

<style lang="scss" scoped>
  .productTable{
    .el-table__footer-wrapper tbody td{
      background: #fff;
    }
  }
</style>

<style lang="scss">
  .rj-page-card{
    .table{
      .el-table{
       .red-row {
          background:  #f0f9eb;
          }
        .cell{
          padding-left: 0;
          padding-right: 0;
        }
      }
    }
  }
</style>
